export const onEnter = (e, callBack) => {
    if (e.key === 'Enter' && !e.shiftKey) {
        callBack();
    }
};
